<template>
	<v-row justify="center">
		<v-col xl="8" lg="10" md="10" sm="12" xs="12"> 
	<v-card outlined>
		<v-card-title
			class="justify-center body-2 pa-1 secondary"
		>
			<v-spacer></v-spacer>
			<span>{{ $ml.get('alert_sounds_settings') }} </span>
			<v-spacer></v-spacer>
			<v-btn
				small
				color="primary"
				@click="show=!show"
			>
				<v-icon small>mdi-plus</v-icon>
			</v-btn>

		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col :md="show ? 3 : 0" v-show="show">
					<v-card outlined>
							<v-card-title
								class="justify-center body-2 secondary pa-1"
							>
								<span v-text="$ml.get('basic_info')"></span>
							</v-card-title>
							<v-card-text class="pt-1">
								<v-text-field
									v-model="inf.name"
									type="text"
									:label="$ml.get('category')"
									hide-details
									outlined
									dense
								></v-text-field>
								<v-switch
									v-model="inf.isPopup"									
									:label="$ml.get('pop_ups')"
									hide-details
								></v-switch>
								<v-switch
									v-model="inf.isSound"									
									:label="$ml.get('sounds')"
									hide-details
								></v-switch>
								<v-text-field
									v-model="inf.timeout"
									type="number"
									:label="$ml.get('timeout')"
									class="col-md-7"
									:placeholder="$ml.get('seconds')"
								>
									<v-icon
										small
										slot="append-outer"
										color="primary"
										v-text="'mdi-timer'"
									></v-icon>
								</v-text-field>
							</v-card-text>
							<v-divider></v-divider>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn 
									small
									color="primary"
									v-text="to_update_item ? $ml.get('update') : $ml.get('save')"
									@click="action=to_update_item ? 'update' : 'save'"
								></v-btn>
								<v-btn
									small
									color="error"
									v-text="$ml.get('close')"
									@click="close_inf"
								></v-btn>
							</v-card-actions>
						</v-card>
				</v-col>
				<v-col :md="show ? 9 : 12">
					<alert_sounds
						:inf_to_table="inf"
						:is_actions="action"
						@is_show="show=$event"
						@is_to_update="to_update_item=$event"
						@edit_item="inf=$event"
						@is_actions="action=$event"
					></alert_sounds>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</v-col>
</v-row>
</template>
<script>
	// import axios from 'axios'
	import alert_sounds from '@/components/sounds/alert_sounds.vue'
	export default{
		name: 'alert_sounds_settings',
		components:{
			alert_sounds
		}, 
		data:() => ({
			show: false,
			inf: {
				isSound: false,
				isPopup: false,
				timeout: 0,
			},
			default_items: [
				'name',
				'isSound',
				'isPopup',
			],
			to_update_item: false,
			action: '',
		}), // data

		methods:{
			close_inf(){
				if (this.show) {
					if(this.inf){
						this.inf={};
					}
					this.to_update_item='';
					this.show=false;
				}
			}, // close ing

		}, // methods

	};
</script>